import React, { FunctionComponent } from 'react';

import ColorPicker from '../../ColorPicker/ColorPicker';
import { DonateButtonProps } from '../DonateButtonTypes';
import WidgetButtonCode from '../WidgetButtonCode';
import { useTranslation } from 'react-i18next';

const StandardButton: FunctionComponent<DonateButtonProps> = ({
  codeBlockType,
  linkId,
  isDefault,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <ColorPicker
        name="buttonColor"
        id="buttonColor"
        label={t('donateButton.standardButton.buttonColorLabel')}
      />
      <WidgetButtonCode
        buttonType="standard"
        codeBlockType={codeBlockType}
        widgetType="donateButton"
        linkId={linkId}
        isDefault={isDefault}
      />
    </>
  );
};

export default StandardButton;
